import React from 'react';
import { makeSticky } from 'tradera-apps/my-tradera/app/components/hoc';
import styles from './sticky-container.module.scss';

const Container = ({ children, className = '' }) => {
    return (
        <div className={`${styles.stickyContainer} ${className}`}>
            {children}
        </div>
    );
};
export const StickyContainer = makeSticky(Container);
